import { Badge, HStack, Icon, Text } from '@chakra-ui/react';
import { FiCalendar, FiDollarSign } from 'react-icons/fi';
import { R$ } from 'shared/helpers/currency';
import { Periodicity } from 'shared/types/periodicity';

type Variant = 'periodicity' | 'total';

interface SummaryBadgeProps {
  variant: Variant;
  periodicity?: Periodicity;
  total?: number;
  showIcon?: boolean;
  labelOverride?: string;
}

const periodicityLabel = (p?: Periodicity) =>
  p === 'yearly' ? 'Anual' : p === 'monthly' ? 'Mensal' : '-';

const colors: Record<Variant, { bg: string; color: string }> = {
  periodicity: { bg: 'yGray.100', color: 'yGray.700' },
  total: { bg: 'green.50', color: 'green.700' },
};

const defaultIcons = {
  periodicity: FiCalendar,
  total: FiDollarSign,
};

export const SummaryBadge: React.FC<SummaryBadgeProps> = ({
  variant,
  periodicity,
  total,
  showIcon = true,
  labelOverride,
}) => {
  const { bg, color } = colors[variant];
  const IconComp = defaultIcons[variant];

  const value =
    variant === 'periodicity' ? periodicityLabel(periodicity) : R$(total ?? 0);

  const label =
    labelOverride ?? (variant === 'periodicity' ? 'Tipo:' : 'Total:');

  return (
    <Badge
      rounded="full"
      bg={bg}
      color={color}
      display="inline-flex"
      alignItems="center"
      gap="8px"
      fontWeight="medium"
      textTransform="none"
      lineHeight="short"
      py="2"
      px="3"
      borderRadius="100px"
      userSelect="none"
      fontSize={'sm'}
    >
      <HStack spacing="8px">
        {showIcon && <Icon as={IconComp} />}
        <Text>
          <Text as="span" fontWeight="semibold">
            {label}
          </Text>{' '}
          {value}
        </Text>
      </HStack>
    </Badge>
  );
};

export const PeriodicityBadge: React.FC<{
  periodicity?: Periodicity;
  showIcon?: boolean;
  labelOverride?: string;
}> = (props) => <SummaryBadge variant="periodicity" {...props} />;

export const TotalBadge: React.FC<{
  total: number;
  showIcon?: boolean;
  labelOverride?: string;
}> = (props) => <SummaryBadge variant="total" {...props} />;
